import {DataFetcher, useIsBotModeEnabled} from '@aboutyou/data-fetcher';
import React from 'react';
import {useDeviceQueryParam} from '../../shared-deprecated/useDeviceQueryParam';
import {CountryDetectionView} from './CountryDetectionView';
import {useGetCountryPopupRequest} from './useGetCountryPopupRequest';

export const CountryDetection = () => {
  const isDeviceinQueryParams = useDeviceQueryParam();
  const isBotModeEnabled = useIsBotModeEnabled();

  if (isDeviceinQueryParams || isBotModeEnabled) {
    return null;
  }

  return <CountryDetectionFetcher />;
};

const CountryDetectionFetcher = () => {
  return (
    <DataFetcher
      request={useGetCountryPopupRequest()}
      View={CountryDetectionView}
      Error={null}
    />
  );
};
